"use client";
import React from 'react';
import { motion } from 'framer-motion';

const CLASH = 'var(--font-clash), "Clash Display", sans-serif';
const MANROPE = 'var(--font-manrope), Manrope, sans-serif';
const LIME = '#ceff1a';

const questions = [
    'Are the leads relevant?',
    'Are they from the right companies?',
    'Are they progressing through the sales process?',
];

function QuestionIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9.5" stroke={LIME} strokeWidth="1.8" />
            <path d="M9.3 9.3a2.7 2.7 0 1 1 3.9 2.4c-.7.4-1.2.9-1.2 1.8" stroke={LIME} strokeWidth="1.8" strokeLinecap="round" />
            <circle cx="12" cy="16.5" r="1" fill={LIME} />
        </svg>
    );
}

export default function LinkedInAdsConnectToSales() {
    return (
        <section className="relative overflow-hidden py-20 md:py-28 px-6 md:px-16 lg:px-24" style={{ background: '#080400' }}>
            <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle, rgba(206,255,26,1) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="max-w-[900px] mx-auto relative z-10 flex flex-col gap-8">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: LIME, fontFamily: CLASH }}
                >
                    Beyond Form Fills
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-3xl md:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: CLASH, color: '#fbfdfd' }}
                >
                    LinkedIn Ads Should Connect to Sales
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.15 }}
                    className="text-base md:text-lg leading-relaxed"
                    style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                >
                    A B2B campaign shouldn&apos;t be judged solely by how many forms it generates. The more important questions are:
                </motion.p>

                <div className="flex flex-col gap-3">
                    {questions.map((q, i) => (
                        <motion.div
                            key={q}
                            initial={{ opacity: 0, x: -12 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
                            className="flex items-center gap-3 rounded-2xl px-5 py-4"
                            style={{ background: 'rgba(206,255,26,0.05)', border: '1px solid rgba(206,255,26,0.16)' }}
                        >
                            <QuestionIcon />
                            <span className="text-sm md:text-base font-semibold" style={{ fontFamily: MANROPE, color: '#fbfdfd' }}>
                                {q}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                    className="text-base md:text-lg leading-relaxed"
                    style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                >
                    We therefore look at advertising as part of the wider funnel — connecting targeting, landing pages, lead capture, qualification and measurement.
                </motion.p>
            </div>
        </section>
    );
}
